( function () {
	'use strict';

	// disable mouse scroll on inputs( type : number )
	function disableInputScroll () {
		function link ( scope, elem ) {
			// cater all browsers
			elem.on( 'mousewheel DOMMouseScroll', function () {
				this.blur();
			} );
		}

		return {
			'link' : link
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'disableInputScroll', disableInputScroll );
} )( );
